<template>
  <div>
    <v-col cols="auto" align-self="center">
      <h4 class="px-1">Multi-Sig Settings</h4>
    </v-col>
    <v-row align="center" class="px-3">
      <v-text-field class="mt-3" label="Required Signatures for Admin Operations" v-model="requiredSignaturesForAdminOperations"/>
    </v-row>
    <v-row align="center" class="px-3">
      <v-text-field class="" label="Required Signatures for User Management Operations" v-model="requiredSignaturesForUserManagementOperations"/>
    </v-row>
    <v-row justify="end" class="px-3">
        <v-btn class="button-text-no-caps"  variant="outlined" color="primary" @click="storeRequiredSignatures()">Save Multi-Signature Settings</v-btn>
    </v-row>
  </div>
</template>

<script>
import dao from '../OrganisationContractDAO'

export default {
  data () {
    return {
      requiredSignaturesForAdminOperations: null,
      requiredSignaturesForUserManagementOperations: null,
    };
  },
  props: {
    organisationId: String,
    organisationName: String
  },
  mounted () {
    this.load();
  },
  methods: {
    async load () {
      const organizationEntry = await dao.getOrganizationEntry(this.organisationId);
      this.requiredSignaturesForAdminOperations = organizationEntry.requiredSignaturesForAdminOperations;
      this.requiredSignaturesForUserManagementOperations = organizationEntry.requiredSignaturesForUserManagementOperations;
    },
    async storeRequiredSignatures () {
      await dao.setRequiredSignatures(this.organisationId, this.requiredSignaturesForAdminOperations, this.requiredSignaturesForUserManagementOperations);
      this.$emit('stored')
    }
  },
};
</script>

<style scoped>


</style>